import {createStore} from 'redux';

let initialState = {
    todos : [ { id : 1 , title : 'Example task to do now' , status : 'Active'}],
    nextId : 2
}

let todoReducer = (state = initialState , action)=>{
    switch (action.type){
        case 'ADD_TODO' :
            let newTodo = { title : action.payload.title , id : state.nextId  , status : 'Active'}
            return {...state , todos : [...state.todos , newTodo] , nextId : state.nextId + 1 }
        case 'DELETE_TODO' :
            return{...state , todos : state.todos.filter((todo)=> todo.id !== action.payload)}
        case 'EDIT_TODO'  :
            return {...state , todos : state.todos.map((todo)=> todo.id === action.payload.id ? {...todo , title : action.payload.title} : todo)}
        case 'MARK_COMPLETED' : 
            return {...state, todos : state.todos.map((todo)=> todo.id === action.payload ? {...todo , status : 'Completed'} : todo)}
        default :
        return state;    
    }
}

let store = createStore(todoReducer);

export default store

